<template>
  <div v-if="showWidget" class="header__progressbar-bottom__wrap">
    <span>{{ loanTitle }}:</span>
    <a @click="showAmountPopup" class="header__progressbar-bottom__amount">
      <span>{{ loanSum.value }} {{ currency }}</span>
      <img src="https://cdn.crezu.net/game_flow/src/assets/img/i-edit.svg" alt="">
    </a>
    <!-- popup -->
    <transition name="fade" v-if="showPopup">
      <div class="header__popup active">
        <p class="header__popup-title">{{placeholder}}</p>
        <input type="tel" class="header__popup-amount" :name="loanSum.name" v-model="inputVal" inputmode="number">
        <div class="header__popup-wrap">
          <input class="header__popup-range"
            type="range"
            v-model="inputVal"
            :name="loanSum.name + '_slider'"
            v-bind:style="{ background: `linear-gradient(90deg, ${mainColor} ${sliderBulletPos}%, #F3F3F3 ${sliderBulletPos}%)`}"
            :min="limits.min"
            :max="limits.max"
            :step="limits.step">
          <p class="form-block__min fsz14">{{limits.min}} {{currency}}</p>
          <p class="form-block__max fsz14">{{limits.max}} {{currency}}</p>
        </div>
        <button @click="closeAmountPopup" class="header__popup-button">OK</button>
      </div>
    </transition>
  </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
  name: 'loanSumWidget',
  data: () => {
    return {
      inputVal: 0,
      mainColor: '#5bb73b',
      limits: '',
      placeholder: '',
      showPopup: false
    }
  },
  computed: {
    ...mapState({
      history: state => state.history,
      currentStep: state => state.currentStep,
      country: state => state.additionalParams.country,
      loanSum: state => {
        let result = {}
        for (const i in state.history) {
          if (state.history[i].name === 'loan_sum') {
            result = state.history[i]
            break
          }
        }
        return result
      },
      currency: state => state.config.params.currency,
      loanTitle: state => {
        if (!state.config) return ''
        for (const i in state.config.main_fields) {
          if (state.config.main_fields[i].name === 'loan_sum') return state.config.main_fields[i].label
        }
      }
    }),
    showWidget () {
      let temporaryLimitation = (+this.country === 1 && window.location.pathname.indexOf('/reg3') > -1) || ['crezu.com.ar', 'andacredito.es', 'andacredito.mx', 'localhost'].indexOf(window.location.hostname) > -1
      return this.loanSum.value && this.history[this.currentStep].name !== 'loan_sum' && temporaryLimitation
    },
    sliderBulletPos () { return (this.inputVal - this.limits.min) / (this.limits.max - this.limits.min) * 100 }
  },
  methods: {
    showAmountPopup () {
      let field = this.$store.getters.getFieldInfoByName('loan_sum')
      this.limits = field.limits
      this.placeholder = field.placeholder
      setTimeout(() => this.updateSliderColor(), 100)
      this.inputVal = this.loanSum.value
      this.showPopup = true
      this.$store.dispatch('pushGAEvent', 'loanSumWidgetOpened')
    },
    closeAmountPopup () {
      this.showPopup = false
      this.$store.commit('UPDATE_FIELD', {name: 'loan_sum', isValid: true, value: this.inputVal})
    },
    updateSliderColor () {
      let newSliderColor = this.$store.getters.getStyle(document.getElementsByClassName('header__popup-button')[0], 'background-color')
      if (newSliderColor) this.mainColor = newSliderColor
    }
  }
}
</script>

<style lang="scss" scoped>
/* line 191, ../sass/index.scss */
.header__progressbar-bottom__wrap {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  font-size: 13px;
  position: relative;
  padding-right: 10px;
  margin-right: -10px;
}
/* line 197, ../sass/index.scss */
.header__progressbar-bottom__wrap > span {
  position: relative;
}

/* line 202, ../sass/index.scss */
a.header__progressbar-bottom__amount {
  margin-left: 5px;
  color: #fff;
  text-decoration: none;
  display: flex;
  align-items: center;
}
/* line 208, ../sass/index.scss */
a.header__progressbar-bottom__amount span {
  font-size: 15px;
  font-weight: 700;
  margin-right: 6px;
}
/* line 213, ../sass/index.scss */
a.header__progressbar-bottom__amount:hover span {
  text-decoration: underline;
}

/* line 215, ../sass/index.scss */
.header__popup {
  top: 22px;
  right: 0px;
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.1);
  position: absolute;
  background: #fff;
  padding: 10px 20px 20px;
  border-radius: 3px;
  color: #000;
  width: 280px;
  text-align: center;
  display: none;
}
/* line 227, ../sass/index.scss */
.header__popup.active {
  display: block;
}
/* line 228, ../sass/index.scss */
.header__popup button {
  background: #5BB73B;
  padding: 10px;
  width: 100%;
  border-radius: 4px;
  color: #fff;
  font-weight: 700;
  font-size: 16px;
  border: none;
}

/* line 239, ../sass/index.scss */
.header__popup-title {
  font-size: 13px;
  font-weight: 500;
  margin-bottom: 10px;
}

/* line 244, ../sass/index.scss */
.header__popup-amount {
  font-size: 26px;
  font-weight: 700;
  margin-bottom: 15px;
}

/* line 249, ../sass/index.scss */
.header__popup-wrap {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 10px;
}

/* line 255, ../sass/index.scss */
.header__popup-range {
  width: 100%;
  height: 2px;
  background: linear-gradient(90deg, #5BB73B 50%, #dedede 50%);
  margin-bottom: 5px;
}
/* line 260, ../sass/index.scss */
.header__popup-range::-webkit-slider-thumb {
  -webkit-appearance: none;
  background: #5BB73B;
  height: 16px;
  width: 16px;
  border-radius: 50%;
}

/* line 268, ../sass/index.scss */
.header__popup-amount {
  width: 100%;
  text-align: center;
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/assetComponents/loanSumWidget.vue